import React, { useEffect, useState, useRef } from "react";
import * as styles from "./concept.css";
import conceptImage from "../../../../assets/Concept/hatugakousogenmaigohan.jpg";
import { useNavigate } from "react-router-dom";

const ConceptPage: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className={styles.container} id="concept">
      <div className={`${styles.content} ${isVisible ? styles.animate : ""}`}>
        <div className={styles.imageWrapper}>
          <img src={conceptImage} alt="Concept" className={styles.image} />
        </div>
        <div className={styles.textContent}>
          <h3 className={styles.subtitle}>"食べて楽しい料理のお店"</h3>
          <div className={styles.description}>
            <p>心と身体を優しく整える料理を通じ、笑顔にあふれる時間をご提供します。</p>

            <p>無農薬無化学肥料の発芽酵素玄米を主食に、麹を使った無添加手造り調味料で仕込んだ野菜中心のバランス良いお菜を楽しめる"酵素玄米プレート"</p>
            <p>月替わりで和風・洋風・アジア風等バリエーション豊かなお菜が楽しめる</p>
            <p>"食べて楽しい"を実感して頂けるお店です。</p>
            <button 
              onClick={() => navigate('/brownrice')} 
              className={styles.link}
            ><br/>
              <b>酵素玄米についてはこちら</b>
            </button>
          </div>
          <button onClick={() => window.location.href = '/ourthoughts'} className={styles.button}>
            CONCEPT
          </button>
        </div>
      </div>
    </section>
  );
};

export default ConceptPage;
